<app-breadcrumb [title]="'Comité'" [items]="['Pesv']" [active_item]="'Comité'"></app-breadcrumb>
<div class="container-fluid">
  <div class="card">
    <div class="card-header d-flex align-items-center bg-primary text-white">
      <i class="icofont icofont-verification-check me-2"></i>
      <h5 class="mb-0"><strong>COMITE PESV</strong></h5>
    </div>

    <div class="card-body">
      <ul ngbNav #nav="ngbNav" class="nav-tabs" [(activeId)]="tabActivo">
        <!-- TAB 1: DESIGNAR COMITÉ -->
        <li [ngbNavItem]="1">
          <a ngbNavLink><strong>DESIGNAR COMITÉ PESV</strong></a>

          <ng-template ngbNavContent>
            <form [formGroup]="formPesv">
              <div class="card-body p-2 p-md-3">

                <!-- WIZARD PROGRESS INDICATOR -->
                <div class="wizard-progress mb-4">
                  <div class="d-flex justify-content-between align-items-center position-relative">
                    <!-- Línea de progreso -->
                    <div class="wizard-line position-absolute w-100"
                      style="height: 2px; background-color: #e0e0e0; top: 50%; transform: translateY(-50%); z-index: 0;">
                    </div>
                    <div class="wizard-line-active position-absolute"
                      [style.width.%]="currentWizardStep === 1 ? 0 : 100"
                      style="height: 2px; background-color: #7366ff; top: 50%; transform: translateY(-50%); z-index: 1; transition: width 0.3s ease;">
                    </div>

                    <!-- Paso 1 -->
                    <div class="wizard-step text-center position-relative" style="z-index: 2; flex: 1; ">
                      <div
                        class="wizard-step-circle mx-auto rounded-circle d-flex align-items-center justify-content-center"
                        [class.active]="currentWizardStep === 1" [class.completed]="currentWizardStep > 1"
                        style="width: 50px; height: 50px; background-color: white; border: 3px solid; transition: all 0.3s ease;"
                        [style.border-color]="currentWizardStep >= 1 ? '#7366ff' : '#e0e0e0'"
                        [style.background-color]="currentWizardStep > 1 ? '#7366ff' : 'white'">
                        <i *ngIf="currentWizardStep > 1" class="icofont icofont-check text-white"
                          style="font-size: 24px;"></i>
                        <span *ngIf="currentWizardStep === 1" class="fw-bold"
                          style="color: #7366ff; font-size: 20px;">1</span>
                        <span *ngIf="currentWizardStep < 1" class="text-dark" style="font-size: 20px;">1</span>
                      </div>
                      <p class="mt-2 mb-0 small fw-bold" [class.text-primary]="currentWizardStep === 1"
                        [class.text-blue]="currentWizardStep !== 1">
                        PASO 1. ASIGNAR FECHA COMITÉ
                      </p>
                    </div>

                    <!-- Paso 2 -->
                    <div class="wizard-step text-center position-relative" style="z-index: 2; flex: 1;">
                      <div
                        class="wizard-step-circle mx-auto rounded-circle d-flex align-items-center justify-content-center"
                        [class.active]="currentWizardStep === 2"
                        style="width: 50px; height: 50px; background-color: white; border: 3px solid; transition: all 0.3s ease;"
                        [style.border-color]="currentWizardStep >= 2 ? '#7366ff' : '#e0e0e0'"
                        [style.background-color]="currentWizardStep > 2 ? '#7366ff' : 'white'">
                        <i *ngIf="currentWizardStep > 2" class="icofont icofont-check text-white"
                          style="font-size: 24px;"></i>
                        <span *ngIf="currentWizardStep === 2" class="fw-bold"
                          style="color: #7366ff; font-size: 20px;">2</span>
                        <span *ngIf="currentWizardStep < 2" class="text-black" style="font-size: 20px;">2</span>
                      </div>
                      <p class="mt-2 mb-0 small fw-bold" [class.text-primary]="currentWizardStep === 2"
                        [class.text-blue]="currentWizardStep !== 2">
                        PASO 2. DESIGNAR INTEGRANTES
                      </p>
                    </div>
                    <div class="wizard-step text-center position-relative" style="z-index: 3; flex: 1;">
                      <div
                        class="wizard-step-circle mx-auto rounded-circle d-flex align-items-center justify-content-center"
                        [class.active]="currentWizardStep === 3"
                        style="width: 50px; height: 50px; background-color: white; border: 3px solid; transition: all 0.3s ease;"
                        [style.border-color]="currentWizardStep >= 3 ? '#7366ff' : '#e0e0e0'"
                        [style.background-color]="currentWizardStep > 3 ? '#7366ff' : 'white'">
                        <i *ngIf="currentWizardStep > 3" class="icofont icofont-check text-white"
                          style="font-size: 24px;"></i>
                        <span *ngIf="currentWizardStep === 3" class="fw-bold"
                          style="color: #7366ff; font-size: 20px;">3</span>
                        <span *ngIf="currentWizardStep < 3" class="text-black" style="font-size: 20px;">3</span>
                      </div>
                      <p class="mt-2 mb-0 small fw-bold" [class.text-primary]="currentWizardStep === 3"
                        [class.text-blue]="currentWizardStep !== 3">
                        PASO 3. CARGAR ACTA
                      </p>
                    </div>
                  </div>
                </div>

                <!-- PASO 1: Seleccionar Número de Comité -->
                <div *ngIf="currentWizardStep === 1">
                  <div class="mt-5">
                    <div class="row g-3 mb-3">
                      <div class="col-md-2 d-none">
                        <label class="form-label fw-bold">
                          NÚMERO DE COMITÉ <span class="text-danger">*</span>
                        </label>
                        <input class="form-control" type="number" placeholder="Número automático"
                          formControlName="numeroComite" readonly>
                      </div>

                      <!-- FECHA ASIGNACION -->
                      <div class="col-md-3">
                        <label class="form-label fw-bold">
                          FECHA ASIGNACION <span class="text-danger">*</span>
                        </label>
                        <input type="date" class="form-control" formControlName="fechainicio"
                          [max]="fechaMaxDesignacion" (change)="onFechaInicioChange()">
                      </div>



                    </div>

                  </div>

                  <div class="alert alert-primary small text-center my-4">
                    <i class="icofont icofont-info-circle me-1"></i>
                    <small>Seleccione el comité para proceder con la designación de integrantes.</small>
                  </div>
                  <!-- BOTÓN CONTINUAR -->
                  <div class="row justify-content-end">
                    <div class="col-md-4 text-end">
                      <button class="btn btn-primary" type="button" (click)="continueWithComite()" [disabled]="!formPesv.get('numeroComite')?.value 
                        || !formPesv.get('fechainicio')?.value 
                        || existeComiteActivo()"
                        [ngbTooltip]="existeComiteActivo() ? 'Ya existe un comité activo. Debe inactivarlo primero.' : ''">
                        <i class="icofont icofont-arrow-right me-1"></i>
                        Siguiente
                      </button>
                    </div>
                  </div>

                </div>
              </div>

              <!-- PASO 2: Formulario de entrada -->
              <div *ngIf="currentWizardStep === 2">
                <div class="mt-4">
                  <!-- Alerta informativa -->
                  <!--  <div class="alert alert-primary small text-center mt-3 mb-2" *ngIf="currentWizardStep === 2">
                    <i class="icofont icofont-info-circle me-1"></i>
                    <small>Seleccione un representante del máximo nivel de la dirección para garantizar respaldo
                      gerencial.</small>
                  </div> -->
                  <!-- Datos y Acciones -->
                  <div class="row g-3 align-items-end">
                    <div class="col-12 col-md-5 col-lg-3">
                      <label class="form-label mb-1">N° DOCUMENTO <span class="text-danger">*</span></label>
                      <input class="form-control" type="number" formControlName="nombre" placeholder="Ingrese el número de documento"
                        formControlName="cedula" (input)="consultarPersonaByCedula()">
                    </div>

                    <div class="col-12 col-md-5 col-lg-3">
                      <label class="form-label mb-1">NOMBRE <span class="text-danger">*</span></label>
                      <input class="form-control" type="text" formControlName="nombre" readonly>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4">
                      <label class="form-label mb-1">CARGO EN EL COMITÉ <span class="text-danger">*</span></label>
                      <ng-select [items]="funciones_mostrar" bindLabel="funcion.descripcion" bindValue="funcion"
                        placeholder="Selecciona" formControlName="funcion" [clearable]="true" [searchable]="true"
                        notFoundText="No disponible" [compareWith]="compareFuncion"
                        (change)="onFuncionSelectChange($event)">
                      </ng-select>
                      <small class="text-dark" *ngIf="cargandoFunciones">Cargando...</small>
                    </div>

                    <div class="col-12 col-md-2 col-lg-2 d-grid">
                      <button class="btn btn-primary" type="button" (click)="agregarIntegrante()">
                        <i class="icofont icofont-plus me-1"></i>Agregar
                      </button>
                    </div>
                  </div>



                  <!-- Tabla de integrantes -->
                  <div class="table-responsive mt-4"
                    *ngIf="currentWizardStep === 2 && integrantesComite && integrantesComite.length > 0">
                    <table class="table table-bordered" id="tblExtractos">
                      <thead class="bg-primary text-white">
                        <tr>
                          <th class="text-center">N° DOCUMENTO</th>
                          <th class="text-center">NOMBRE</th>
                          <th class="text-center">CARGO LABORAL</th>
                          <th class="text-center">CARGO EN EL COMITÉ</th>
                          <th class="text-center">ACCIÓN</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of integrantesComite; let i = index; trackBy: trackByIntegrante"
                          class="text-center">
                          <td>{{ item.cedula }}</td>
                          <td>{{ item.nombre }}</td>
                          <td>{{ item.cargoLaboral || '-' }}</td>

                          <td>
                            <span class="badge bg-primary">{{ item.idfuncion.descripcion }}</span>
                          </td>

                          <!-- ACCIÓN: eliminar + más opciones (lado a lado) -->
                          <td>
                            <div class="d-flex gap-1 justify-content-center">
                              <button class="btn btn-danger btn-sm" (click)="eliminarIntegrante(i)"
                                title="Eliminar integrante">
                                <i class="icofont icofont-trash"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>


                    </table>
                  </div>



                  <!-- Botón Volver -->

                  <div class="row mt-4" *ngIf="currentWizardStep === 2">
                    <div class="col-12 d-flex justify-content-between align-items-center">

                      <button class="btn btn-outline-secondary" type="button" (click)="reiniciarComite()">
                        <i class="icofont icofont-arrow-left me-1"></i>
                        Volver al Paso 1
                      </button>

                      <button *ngIf="integrantesComite?.length >= 3" class="btn btn-primary" type="button"
                        (click)="avanzarAAsignarFunciones()">
                        Siguiente
                        <i class="icofont icofont-arrow-right ms-1"></i>
                      </button>

                    </div>
                  </div>
                  <!-- Aviso de mínimo integrantes -->
                  <div class="row mt-2"
                    *ngIf="currentWizardStep === 2 && integrantesComite && integrantesComite.length > 0 && integrantesComite.length < 3">
                    <div class="col-md-12">
                      <div class="alert alert-danger text-center" role="alert">
                        <strong>Atención:</strong> Se requieren al menos 3 integrantes para crear el comité.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="currentWizardStep === 3">

                <!-- Selects por integrante: mostrar nombre y permitir seleccionar función/detalle según cargo -->
                <!--   <div class="row g-3 mb-3"
                    *ngIf="integrantesComite && integrantesComite.length &&  !hayDocumentosCargadosComiteActual()">
                    <div class="col-12">
                      <div class="card">
                        <div
                          class="card-header bg-light d-flex justify-content-between align-items-center flex-wrap gap-2">
                          <strong>Funciones por Integrante</strong>
                          <button class="btn btn-sm btn-primary" type="button" (click)="abrirModalFuncionDetalle()">
                            <i class="icofont icofont-plus me-1"></i>Nueva relación función/detalle
                          </button>
                        </div>
                        <div class="card-body">
                          <div *ngFor="let integ of integrantesComite; let idx = index" class="mb-3">
                            <div class="row g-2 align-items-center">
                              <div class="col-12 col-md-4">
                                <label class="form-label mb-1">INTEGRANTE:</label>
                                <input class="form-control" [value]="integ.nombre" readonly />
                              </div>

                              <div class="col-12 col-md-4 d-none">
                                <label class="form-label mb-1">CARGO EN EL COMITÉ:</label>
                                <ng-select [items]="obtenerFuncionesParaIntegrante(integ)" bindLabel="descripcion"
                                  bindValue="id" [clearable]="true" [searchable]="true" [(ngModel)]="integ.n_funcion"
                                  [ngModelOptions]="{ standalone: true }"
                                  (change)="onSeleccionFuncionIntegrante(integ, $event)">
                                </ng-select>
                                <small class="text-dark d-block mt-1" *ngIf="integ.n_funcion">
                                  <i class="icofont icofont-check"></i> <strong>{{ integ.funcion }}</strong>
                                </small>
                              </div>

                              <div class="col-12 col-md-4">
                                <label class="form-label mb-1">FUNCIÓN:</label>
                                <ng-select [items]="integ._opcionesDetalle || []" bindLabel="label" bindValue="value"
                                  [multiple]="true" [clearable]="true" [searchable]="true"
                                  [(ngModel)]="integ.detallesSeleccionados" [ngModelOptions]="{ standalone: true }"
                                  [disabled]="!integ._opcionesDetalle || !integ._opcionesDetalle.length"
                                  (change)="onSeleccionDetalleIntegrante(integ, $event)" [closeOnSelect]="false">
                                </ng-select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> -->


                <!-- Documento y Función/Detalle -->
                <div class="row g-3 mb-3 my-4">
                  <div class="col-12 col-lg-12">
                    <div class="card h-100">
                      <div class="d-flex align-items-center justify-content-center">
                        <input type="file" class="d-none" id="fileInputComitePesv" [attr.accept]="acceptDocumentoComite"
                          (change)="onFileChangeComite($event)" />

                        <label for="fileInputComitePesv"
                          class="dropzone-label w-100 d-flex flex-column align-items-center justify-content-center py-4 border border-primary rounded cursor-pointer"
                          tabindex="0" (dragover)="onDragOverComite($event)" (dragleave)="onDragLeaveComite($event)"
                          (drop)="onDropComite($event)">
                          <ng-container *ngIf="archivoDigitalComite.file; else noFileComite">
                            <i class="icofont icofont-file-document fs-1 text-primary mb-2"></i>
                            <small class="text-dark text-truncate" [title]="archivoDigitalComite.file?.name">{{
                              archivoDigitalComite.file?.name }}</small>
                          </ng-container>
                          <ng-template #noFileComite>
                            <i class="icofont icofont-upload fs-1 text-primary mb-2"></i>
                            <p class="mb-0 fw-semibold text-primary text-center">Cargar soporte del Comité PESV</p>
                          </ng-template>
                        </label>
                      </div>
                      <div class="card-footer d-flex justify-content-center gap-2">
                        <button *ngIf="archivoDigitalComite.file" class="btn btn-danger w-100" type="button"
                          (click)="removeArchivoComite()">Eliminar</button>
                      </div>
                    </div>
                  </div>

                </div>
                <div class="col-12 d-flex justify-content-between align-items-center">

                  <button class="btn btn-outline-secondary" type="button" (click)="volverAPaso2()">
                    <i class="icofont icofont-arrow-left me-1"></i>
                    Volver al Paso 2
                  </button>
                  <!-- Botón Guardar Comité -->
                  <button class="btn btn-primary" type="button" (click)="guardarComite()"
                    [disabled]="cargando || integrantesComite.length < 3 || !archivoDigitalComite.file"
                    [ngbTooltip]="!archivoDigitalComite.file ? 'Debe cargar el documento del comité PESV para guardar.' : ''">
                    <i class="icofont icofont-save me-1"></i>
                    {{ cargando ? 'Guardando...' : 'Guardar Comité' }}
                  </button>

                </div>
               

              </div>
            </form>
          </ng-template>
        </li>

        <!-- TAB 2: HISTORIAL DE COMITÉS Y SUS INTEGRANTES -->
        <li [ngbNavItem]="2">
          <a ngbNavLink><strong>HISTORIAL DEL COMITE</strong></a>

          <ng-template ngbNavContent>
            <div class="card-body p-2 p-md-3">
              <div class="card card-absolute rounded">
                <div class="card-header bg-primary d-flex align-items-center text-white">
                  <i class="icofont icofont-list me-2"></i>
                  <h5 class="mb-0"><strong>HISTORIAL DE COMITÉS</strong></h5>
                </div>

                <div class="card-body">
                  <!-- Filtro dropdown -->
                  <div class="row mb-2 g-2" *ngIf="!cargandoHistorial">
                    <div class="col-sm-12 col-md-3">
                      <div class="dropdown w-100">
                        <button class="btn btn-sm btn-primary dropdown-toggle w-100" type="button" id="dropdownFiltro"
                          data-bs-toggle="dropdown" aria-expanded="false">
                          <i class="icofont icofont-filter me-1"></i>
                          <span *ngIf="filtroComite === 'activos'">Activos</span>
                          <span *ngIf="filtroComite === 'inactivos'">Inactivos</span>
                          <span *ngIf="filtroComite === 'todos'">Todos</span>
                        </button>
                        <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownFiltro">
                          <li>
                            <a class="dropdown-item" href="javascript:void(0)" (click)="cambiarFiltroComite('activos')"
                              [class.active]="filtroComite === 'activos'">
                              <i class="icofont icofont-check-circled me-2"></i>Activos
                            </a>
                          </li>
                          <li>
                            <a class="dropdown-item" href="javascript:void(0)"
                              (click)="cambiarFiltroComite('inactivos')" [class.active]="filtroComite === 'inactivos'">
                              <i class="icofont icofont-close-circled me-2"></i>Inactivos
                            </a>
                          </li>
                          <li>
                            <hr class="dropdown-divider">
                          </li>
                          <li>
                            <a class="dropdown-item" href="javascript:void(0)" (click)="cambiarFiltroComite('todos')"
                              [class.active]="filtroComite === 'todos'">
                              <i class="icofont icofont-list me-2"></i>Todos
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-4 ms-auto">
                      <div class="input-group">
                        <input type="text" class="form-control" placeholder="Buscar en historial..."
                          [(ngModel)]="searchTextHistorialComite" (input)="aplicarFiltroHistorialComite()" />
                        <span class="input-group-text">
                          <i class="fa fa-search"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                  <!-- Loader -->
                  <div *ngIf="cargandoHistorial" class="text-center py-5">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Cargando...</span>
                    </div>
                    <p class="mt-2 text-dark">Cargando comités...</p>
                  </div>

                  <!-- Tabla de comités con números -->
                  <ng-container *ngIf="!cargandoHistorial">
                    <div class="table-responsive my-3">
                      <table class="table table-bordered table-hover" id="tblComiteHistorial">
                        <thead class="bg-primary text-white">
                          <tr>
                            <th class="text-center">N° COMITÉ</th>
                            <th class="text-center">FECHA ASIGNACIÓN</th>
                            <th class="text-center">ESTADO</th>
                            <th class="text-center">ACCIONES</th>
                          </tr>
                        </thead>
                        <tbody>
                          <ng-container
                            *ngFor="let numeroComite of numerosComiteHistorialVista | paginate: { id: 'historialComite', itemsPerPage: pageSize1, currentPage: page1 }; trackBy: trackByHistorial">
                            <!-- Fila del número de comité -->
                            <tr class="text-center">
                              <td>{{'#' + numeroComite.numero }}</td>
                              <td>{{ (numeroComite.fechainicio) | date:'dd/MM/yyyy'}}</td>
                              <td>
                                <span *ngIf="numeroComite.esDefault" class="badge bg-primary">
                                  POR DEFECTO
                                </span>
                                <span *ngIf="!numeroComite.esDefault && numeroComite.estado === 1"
                                  class="badge bg-success">
                                  ACTIVO
                                </span>
                                <span *ngIf="!numeroComite.esDefault && numeroComite.estado === 0"
                                  class="badge bg-secondary">
                                  INACTIVO
                                </span>
                              </td>

 <!-- Acciones -->
            <td class="text-center">
              <div class="d-flex justify-content-center gap-1">
                <button class="btn btn-sm btn-outline-primary rounded-pill btn-rounded"
                  (click)="abrirModalIntegrantes(numeroComite)" ngbTooltip="Ver Integrantes del Comité">
                  <i class="icofont icofont-users-alt-3" style="font-size:.85rem;"></i>
                </button>             
             
                <button class="btn btn-sm btn-outline-success rounded-pill btn-rounded"
                  (click)="abrirModalActas(numeroComite.numero)" ngbTooltip="Ver Actas del Comité">
                  <i class="icofont icofont-file-alt" style="font-size:.85rem;"></i>
                </button>
                 <button class="btn btn-sm btn-outline-info rounded-pill btn-rounded"
                  (click)="VerDocumentoComite(numeroComite.numero)" ngbTooltip="Visualizar documento">
                  <i class="icofont icofont-printer" style="font-size:.85rem;"></i>
                </button>
                 <button class="btn btn-sm btn-outline-warning rounded-pill btn-rounded"
                   (click)="descargarDocumentoComite(numeroComite.numero)" ngbTooltip="Descargar Acta">
                  <i class="icon icon-download"   style="font-size:.85rem;"></i>
                </button>
                 <button class="btn btn-sm btn-outline-secondary rounded-pill btn-rounded" *ngIf="numeroComite.estado === 1"
                 (click)="inactivarComite(numeroComite.numero)" ngbTooltip="Inactivar Comité">
                  <i class="icofont icofont-trash" style="font-size:.85rem;"></i>
                </button>
              </div>
            </td>     
         <!--      <td>
                                <div class="action text-center">
                                  <ul class="list-inline mb-0">
                                    <li class="list-inline-item" *ngIf="!numeroComite.esDefault">
                                      <a href="javascript:void(0)" (click)="abrirModalIntegrantes(numeroComite)"
                                        [class.disabled]="cargandoIntegrantes[numeroComite.numero]"
                                        ngbTooltip="Ver integrantes">
                                        <i class="icofont icofont-users-alt-3"></i>
                                      </a>
                                    </li>

                                    <li class="list-inline-item" *ngIf="!numeroComite.esDefault">
                                      <a href="javascript:void(0)" (click)="abrirModalActas(numeroComite.numero)"
                                        [class.disabled]="cargandoActas[numeroComite.numero]" ngbTooltip="Ver actas">
                                        <i class="icofont icofont-file-alt" style="color: #5a5a5a;"></i>
                                      </a>
                                    </li>

                                    <li class="list-inline-item">
                                      <a href="javascript:void(0)" (click)="VerDocumentoComite(numeroComite.numero)"
                                        [class.disabled]="descargandoDocumentoComiteId === (numeroComite.esDefault ? 0 : numeroComite.numero)"
                                        [style.pointer-events]="descargandoDocumentoComiteId === (numeroComite.esDefault ? 0 : numeroComite.numero) ? 'none' : 'auto'"
                                        ngbTooltip="Visualizar documento">

                                        <i class="icon-eye"
                                          *ngIf="descargandoDocumentoComiteId !== (numeroComite.esDefault ? 0 : numeroComite.numero)">
                                        </i>

                                        <span class="spinner-border spinner-border-sm"
                                          *ngIf="descargandoDocumentoComiteId === (numeroComite.esDefault ? 0 : numeroComite.numero)">
                                        </span>

                                      </a>
                                    </li>
                                    <li class="list-inline-item">
                                      <a href="javascript:void(0)"
                                        (click)="descargarDocumentoComite(numeroComite.numero)"
                                        [class.disabled]="descargandoDocumentoComiteId === (numeroComite.esDefault ? 0 : numeroComite.numero)"
                                        [style.pointer-events]="descargandoDocumentoComiteId === (numeroComite.esDefault ? 0 : numeroComite.numero) ? 'none' : 'auto'"
                                        ngbTooltip="Descargar documento">

                                        <i class="icon-download"
                                          *ngIf="descargandoDocumentoComiteId !== (numeroComite.esDefault ? 0 : numeroComite.numero)">
                                        </i>

                                        <span class="spinner-border spinner-border-sm"
                                          *ngIf="descargandoDocumentoComiteId === (numeroComite.esDefault ? 0 : numeroComite.numero)">
                                        </span>

                                      </a>
                                    </li>

                                    <li class="list-inline-item delete"
                                      *ngIf="!numeroComite.esDefault && numeroComite.estado === 1">
                                      <a href="javascript:void(0)" (click)="inactivarComite(numeroComite.numero)"
                                        ngbTooltip="Inactivar Comité">
                                        <i class="icon-trash"></i>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </td> -->
                            </tr>

                          </ng-container>
                        </tbody>
                      </table>
                    </div>

                    <div class="d-flex justify-content-between align-items-center mt-4 flex-wrap gap-2">
                      <div class="d-flex align-items-center">
                        <label for="pageSizeComiteHistorial" class="me-2">Mostrar:</label>
                        <select id="pageSizeComiteHistorial" class="form-select w-auto" [(ngModel)]="pageSize1"
                          (change)="page1 = 1">
                          <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
                        </select>
                        <span class="ms-2">registros por página</span>
                      </div>

                      <div class="text-center flex-grow-1">
                        Total Registros:
                        <a class="badge badge-primary"><b>{{ numerosComiteHistorialVista?.length }}</b></a>
                      </div>

                      <div class="text-end paginador-personalizado">
                        <pagination-controls id="historialComite" (pageChange)="page1 = $event" [maxSize]="5"
                          [directionLinks]="true" [autoHide]="true" previousLabel="Anterior" nextLabel="Siguiente">
                        </pagination-controls>
                      </div>
                    </div>

                    <div class="mt-3 d-flex justify-content-center flex-wrap gap-2">
                      <button class="btn btn-outline-success-2x btn-sm" type="button"
                        (click)="exportarExcelHistorialComite()">
                        <i class="icofont icofont-file-excel"></i> EXCEL
                      </button>
                      <button class="btn btn-outline-danger-2x btn-sm" type="button"
                        (click)="exportarPdfHistorialComite()">
                        <i class="icofont icofont-file-pdf"></i> PDF
                      </button>
                    </div>


                  </ng-container>

                  <!-- Se mantiene tabla con documento por defecto cuando no hay registros -->
                </div>
              </div>
            </div>
          </ng-template>
        </li>

        <li [ngbNavItem]="3">
          <a ngbNavLink><strong>ACTA REUNIÓN</strong></a>

          <ng-template ngbNavContent>
            <form [formGroup]="formPesv" class="card-body p-2 p-md-3">

              <!-- Selector de integrantes -->
              <div class="card card-absolute rounded mb-4">
                <div class="card-header bg-primary">
                  <h5 class="text-white text-uppercase mb-0">
                    <strong>Seleccionar Integrantes</strong>
                  </h5>
                </div>

                <div class="card-body mt-3">
                  <div class="row">
                    <div class="card border-0 shadow-sm mb-3">

  <div class="card-body">

    <div class="row g-3">

      <!-- Selector -->
      <div class="col-12">

        <label class="form-label fw-semibold">
          <i class="icofont icofont-users-alt-4 text-primary me-1"></i>
          Integrante de la Reunión
          <span class="text-danger">*</span>
        </label>

        <ng-select
          [items]="integrantesActivos"
          bindLabel="nombre"
          bindValue="cedula"
          placeholder="Seleccione un integrante"
          formControlName="integranteSeleccionado"
          [searchable]="true"
          [clearable]="true">

        </ng-select>

      </div>

      <!-- Acciones -->
      <div class="col-12" style="align-items: center;">
      
        <div class="row g-2">
      
          <div class="col-12 col-md-12 col-sm-12 col-xl-2">
      
            <button class="btn btn-primary w-100" type="button" (click)="agregarIntegranteDesdeComiteActivo()">
      
              <i class="icofont icofont-plus-circle me-2"></i>
              Agregar Asistente
      
            </button>
      
          </div>
      
          <div class="col-12 col-md-12 col-sm-12 col-xl-2">
      
            <button class="btn btn-outline-primary w-100" type="button" (click)="agregarTodosIntegrantesDesdeComiteActivo()">
      
              <i class="icofont icofont-users-alt-3 me-2"></i>
              Agregar Todos
      
            </button>
      
          </div>
      
          <div class="col-12 col-md-12 col-sm-12 col-xl-2">
      
            <button class="btn btn-secondary w-100" type="button" (click)="agregarInvitadoAReunion()">
      
              <i class="icofont icofont-user-alt-4 me-2"></i>
              Agregar Invitado
      
            </button>
      
          </div>
      
        </div>
      
      </div>

    </div>

  </div>

</div>
                  </div>
                    <!-- Tabla de integrantes -->
                  <div class="table-responsive table-hover mt-4" *ngIf="integrantesReunion?.length">
                    <table class="table table-bordered" id="tblIntegrantesReunion">
                      <thead class="bg-primary text-white">
                        <tr class="text-center">
                          <th>N° DOCUMENTO</th>
                          <th>NOMBRE</th>
                          <th>CARGO EN EL COMITÉ</th>
                          <th>ACCIÓN</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of integrantesReunion; let i = index; trackBy: trackByIntegrante"
                          class="text-center">
                          <td>{{ item.cedula }}</td>
                          <td class="text-center">{{ item.nombre }}</td>
                          <td><span class="badge bg-secondary">{{ item.funcionDetalle.descripcion }}</span></td>



                          <td>
                            <button class="btn btn-danger btn-sm" (click)="eliminarIntegranteReunion(i)">
                              <i class="icofont icofont-trash"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div *ngIf="!integrantesReunion?.length" class="text-center py-5 text-dark">
                    <i class="icofont icofont-users-alt-3" style="font-size: 48px;"></i>
                    <p class="mt-2">No hay integrantes agregados</p>
                  </div>
                </div>
              </div>

              <!-- Formulario de datos de reunión -->
              <div class="card card-absolute rounded mt-4 pt-2 mt-5" *ngIf="integrantesReunion?.length">
                <div class="card-header bg-primary">
                  <h5 class="text-white mb-0">
                    <i class="icofont icofont-clip-board me-2"></i>DATOS DE LA REUNIÓN
                  </h5>
                </div>
                <div class="card-body mt-4">
                  <div class="row g-3 mb-4">
                    <!-- Fecha -->
                    <div class="col-md-3">
                      <label class="form-label fw-bold">Fecha de la Reunión: <span class="text-danger">*</span></label>
                      <input type="date" class="form-control" formControlName="fechaReunion"
                        [class.is-invalid]="formPesv.get('fechaReunion')?.invalid && formPesv.get('fechaReunion')?.touched">
                    </div>
                    <!-- Hora Inicio -->
                    <div class="col-md-3">
                      <label class="form-label fw-bold">Hora Inicio: <span class="text-danger">*</span></label>
                      <input type="time" class="form-control" formControlName="horaInicio"
                        [class.is-invalid]="formPesv.get('horaInicio')?.invalid && formPesv.get('horaInicio')?.touched">
                    </div>
                    <!-- Hora Fin -->
                    <div class="col-md-3">
                      <label class="form-label fw-bold">Hora Fin: <span class="text-danger">*</span></label>
                      <input type="time" class="form-control" formControlName="horaFinalizacion"
                        [class.is-invalid]="formPesv.get('horaFinalizacion')?.invalid && formPesv.get('horaFinalizacion')?.touched">
                    </div>
                    <!-- Lugar -->
                    <div class="col-md-3">
                      <label class="form-label fw-bold">Lugar: <span class="text-danger">*</span></label>
                      <input type="text" class="form-control" formControlName="lugarReunion"
                        placeholder="Sala de juntas"
                        [class.is-invalid]="formPesv.get('lugarReunion')?.invalid && formPesv.get('lugarReunion')?.touched">
                    </div>
                  </div>

                  <div class="row g-3 mb-4">
                    <!-- Nombre Comité -->
                    <div class="col-md-3">
                      <label class="form-label fw-bold">Nombre Comité:</label>
                      <input type="text" class="form-control bg-light" formControlName="nombreComite" readonly>
                    </div>
                    <!-- Empresa -->
                   <!--  <div class="col-md-3">
                      <label class="form-label fw-bold">Empresa: <span class="text-danger">*</span></label>
                      <input type="text" class="form-control bg-light" formControlName="empresa" placeholder="Empresa"
                        disabled
                        [class.is-invalid]="formPesv.get('empresa')?.invalid && formPesv.get('empresa')?.touched">
                    </div> -->
                    <!-- Proxima reunión -->
                    <div class="col-md-3">
                      <label class="form-label fw-bold">Proxima reunión: <span class="text-danger">*</span></label>
                      <input type="date" class="form-control" formControlName="vigenciaDesde"
                        [min]="fechaMinVigenciaDesde" (change)="onVigenciaDesdeChange()"
                        [class.is-invalid]="formPesv.get('vigenciaDesde')?.invalid && formPesv.get('vigenciaDesde')?.touched">
                      <div class="invalid-feedback" *ngIf="formPesv.get('vigenciaDesde')?.hasError('fechaPasada')">
                        La proxima reunión debe ser hoy o una fecha posterior.
                      </div>
                    </div>

                    <div class="col-md-3">
                      <label class="form-label fw-bold">
                        Tipo de Reunión<span class="text-danger">*</span>
                      </label>
                      <ng-select [items]="tipoActa" bindLabel="descripcion" bindValue="id"
                        placeholder="Selecciona una función" formControlName="tipoReunion" [clearable]="true"
                        [searchable]="true" notFoundText="No hay funciones disponibles">
                      </ng-select>
                    </div>
                  </div>

                  <!-- FUNCIÓN EN EL COMITÉ -->


                  <div class="row g-3 mb-4">
                    <!-- Temas Tratados -->
                    <div class="col-md-12">
                      <label class="form-label fw-bold">Temas Tratados en la Reunión <span
                          class="text-danger">*</span></label>
                      <textarea class="form-control" rows="5" formControlName="temasTratados"
                        placeholder="Describa los temas tratados durante la reunión..."
                        [class.is-invalid]="formPesv.get('temasTratados')?.invalid && formPesv.get('temasTratados')?.touched"></textarea>
                      <div class="invalid-feedback">Los temas tratados son obligatorios (mínimo 10 caracteres).</div>
                      <small class="text-dark">Máximo 5000 caracteres</small>
                    </div>
                  </div>

                  <div class="row g-3 mb-2">
                    <!-- Archivo PDF del Acta -->
                    <div class="col-md-12">
                  
                      <label class="form-label fw-bold">
                        Archivo PDF del Acta (Opcional)
                      </label>
                  
                      <input type="file" class="d-none" id="fileInputActaPdf" accept=".pdf" (change)="onPdfFileSelected($event)" />
                  
                      <div class="d-flex flex-column">
                  
                        <!-- Área de carga -->
                        <label for="fileInputActaPdf"
                          class="dropzone-label w-100 d-flex flex-column align-items-center justify-content-center py-4 border border-primary rounded cursor-pointer"
                          tabindex="0" (dragover)="onDragOverPdfActa($event)" (dragleave)="onDragLeavePdfActa($event)"
                          (drop)="onDropPdfActa($event)">
                  
                          <ng-container *ngIf="pdfFileSelected; else noFileActaPdf">
                  
                            <i class="icofont icofont-file-pdf fs-1 text-danger mb-2"></i>
                  
                            <div class="text-center">
                              <div class="fw-bold text-primary">
                                {{ pdfFileSelected?.name }}
                              </div>
                  
                              <small class="text-muted">
                                {{ formatFileSize(pdfFileSelected.size) }}
                              </small>
                            </div>
                  
                          </ng-container>
                  
                          <ng-template #noFileActaPdf>
                  
                            <i class="icofont icofont-upload fs-1 text-primary mb-2"></i>
                  
                            <h6 class="mb-1 text-primary">
                              Cargar PDF del Acta
                            </h6>
                  
                            <small class="text-muted">
                              Arrastre el archivo aquí o haga clic para seleccionarlo
                            </small>
                  
                          </ng-template>
                  
                        </label>
                  
                        <!-- Botón eliminar -->
                        <div *ngIf="pdfFileSelected" class="d-flex justify-content-center mt-3">
                  
                          <button class="btn btn-outline-danger px-4" type="button" (click)="removePdfActaSeleccionado()">
                  
                            <i class="icofont icofont-trash me-2"></i>
                            Eliminar archivo
                  
                          </button>
                  
                        </div>
                  
                      </div>
                  
                      <small class="text-muted d-block mt-2">
                        Solo se permite archivo PDF (máximo 10 MB).
                      </small>
                  
                    </div>
                  </div>


                </div>
              
              </div>
  <!-- Botón Guardar Acta -->
                <div class="row mt-4 mb-4">
                  <div class="col-md-12 text-center"  *ngIf="!modoEdicion">
                    <button class="btn btn-success btn-lg" type="button" (click)="guardarActaReunion()"
                      [disabled]="cargando">
                      <i class="icofont icofont-save me-2"></i>{{ cargando ? 'Guardando...' : 'Guardar' }}
                    </button>
                  </div>
                   <div class="col-md-12 text-center" *ngIf="modoEdicion" >
                    <button class="btn btn-success btn-lg" type="button" (click)="editarActaReunion()"
                      [disabled]="cargando">
                      <i class="icofont icofont-save me-2"></i>{{ cargando ? 'Actualizando...' : 'Actualizar' }}
                    </button>
                  </div>
                </div>
            </form>
          </ng-template>
        </li>
      </ul>

      <div [ngbNavOutlet]="nav" class="mt-3"></div>
    </div>
  </div>
</div>

<!-- MODAL: Listado de Integrantes -->
<ng-template #modalIntegrantesComite let-modal>
  <div class="card border-4 rounded-3">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
      <h5 class="mb-0"><strong>INTEGRANTES DEL COMITÉ {{ numeroComiteIntegrantesModal }}</strong></h5>
      <button type="button" class="btn-close btn-close-white" (click)="modal.dismiss()" aria-label="Close"></button>
    </div>

    <div class="modal-body">
      <div class="alert alert-primary fs-6 mb-3">
        <i class="icofont icofont-info-circle me-1"></i>
        Listado de integrantes del comité <strong>No. {{ numeroComiteIntegrantesModal }}</strong>
      </div>

      <div class="row mb-2 g-2">
        <div class="col-sm-12 col-md-4 ms-auto">
          <div class="input-group">
            <input type="text" class="form-control"
              placeholder="Buscar por número de documento, nombre, cargo, función..."
              [(ngModel)]="searchTextIntegrantesModal" (input)="aplicarFiltroIntegrantesModal()" />
            <span class="input-group-text">
              <i class="fa fa-search"></i>
            </span>
          </div>
        </div>
      </div>

      <div *ngIf="cargandoIntegrantesModal" class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Cargando...</span>
        </div>
        <p class="mt-2 text-dark">Cargando integrantes...</p>
      </div>

      <div class="table-responsive table-hover my-3"
        *ngIf="!cargandoIntegrantesModal && integrantesModalListaFiltrada?.length">
        <table class="table table-bordered" id="tblIntegrantesModal">
          <thead class="bg-primary text-white">
            <tr>
              <th class="text-center">N° DOCUMENTO</th>
              <th class="text-center">NOMBRE</th>
              <th class="text-center">CARGO</th>
              <th class="text-center">CARGO EN EL COMITÉ</th>
              <th class="text-center">ESTADO</th>
              <th class="text-center">MOTIVO</th>
              <th class="text-center">ACCIONES</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let integrante of integrantesModalListaFiltrada | paginate: { id: 'integrantesComite', itemsPerPage: pageSizeIntegrantesModal, currentPage: pageIntegrantesModal }"
              class="text-center align-middle">
              <td class="fw-bold">{{ integrante.cedula }}</td>
              <td class="text-start">{{ integrante.nombre }}</td>
              <td class="small">{{ integrante.cargoLaboral || '-' }}</td>
              <td><span class="badge bg-primary">{{ integrante.funcionDetalle.descripcion }}</span></td>
              <td>
                <span *ngIf="integrante.estado === 1" class="badge bg-success">
                  <i class="icofont icofont-check-circled"></i> ACTIVO
                </span>
                <span *ngIf="integrante.estado === 0" class="badge bg-secondary">
                  <i class="icofont icofont-close-circled"></i> INACTIVO
                </span>
              </td>
              <td class="small">{{ integrante.ComiteMotivoData?.descripcion || '-' }}</td>
              <td>
                <div class="action text-center">
                  <ul class="list-inline mb-0">
                    <li class="list-inline-item edit" *ngIf="integrante.estado === 1">
                      <a href="javascript:void(0)">
                        <i class="icon-pencil-alt"
                          (click)="editarIntegrante(numeroComiteIntegrantesModal || 0, integrante)"
                          ngbTooltip="Editar"></i>
                      </a>
                    </li>
                    <li class="list-inline-item delete" *ngIf="integrante.estado === 1">
                      <a href="javascript:void(0)"
                        (click)="inactivarIntegrante(numeroComiteIntegrantesModal || 0, integrante)"
                        [class.disabled]="contarIntegrantesActivos(numeroComiteIntegrantesModal || 0) <= 3"
                        [ngbTooltip]="contarIntegrantesActivos(numeroComiteIntegrantesModal || 0) <= 3 ? 'Mínimo 3 integrantes activos requeridos' : 'Inactivar'">
                        <i class="icon-trash"
                          [style.opacity]="contarIntegrantesActivos(numeroComiteIntegrantesModal || 0) <= 3 ? '0.5' : '1'"></i>
                      </a>
                    </li>
                    <li class="list-inline-item" *ngIf="integrante.estado === 0">
                      <a href="javascript:void(0)"
                        (click)="activarIntegrante(numeroComiteIntegrantesModal || 0, integrante)" ngbTooltip="Activar">
                        <i class="icofont icofont-check-circled" style="color: #28a745; font-size: 18px;"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="text-center py-4 text-primary"
        *ngIf="!cargandoIntegrantesModal && !integrantesModalListaFiltrada?.length">
        <i class="icofont icofont-users-alt-3" style="font-size: 32px;"></i>
        <p class="mb-0 mt-2">No hay integrantes registrados para este comité</p>
      </div>

      <div class="d-flex justify-content-between align-items-center mt-4 flex-wrap gap-2"
        *ngIf="!cargandoIntegrantesModal && integrantesModalListaFiltrada?.length">
        <div class="d-flex align-items-center">
          <label for="pageSizeIntegrantesModal" class="me-2">Mostrar:</label>
          <select id="pageSizeIntegrantesModal" class="form-select w-auto" [(ngModel)]="pageSizeIntegrantesModal"
            (change)="pageIntegrantesModal = 1">
            <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
          </select>
          <span class="ms-2">registros por página</span>
        </div>

        <div class="text-center flex-grow-1">
          Total Registros:
          <a class="badge badge-primary"><b>{{ integrantesModalListaFiltrada?.length || 0 }}</b></a>
        </div>

        <div class="text-end paginador-personalizado">
          <pagination-controls id="integrantesComite" (pageChange)="pageIntegrantesModal = $event" [maxSize]="5"
            [directionLinks]="true" [autoHide]="true" previousLabel="Anterior" nextLabel="Siguiente">
          </pagination-controls>
        </div>
      </div>

      <div class="mt-3 d-flex justify-content-end"
        *ngIf="estadoComiteIntegrantesModal === 1 && numeroComiteIntegrantesModal">

        <button class="btn btn-sm btn-success" type="button"
          (click)="abrirModalAgregarIntegrante(numeroComiteIntegrantesModal)">
          <i class="icofont icofont-ui-add me-1"></i>Agregar Integrante
        </button>
      </div>

      <div class="mt-3 d-flex justify-content-center flex-wrap gap-2" *ngIf="integrantesModalListaFiltrada?.length">
        <button class="btn btn-outline-success-2x btn-sm" type="button" (click)="exportarExcelIntegrantesModal()">
          <i class="icofont icofont-file-excel"></i> EXCEL
        </button>
        <button class="btn btn-outline-danger-2x btn-sm" type="button" (click)="exportarPdfIntegrantesModal()">
          <i class="icofont icofont-file-pdf"></i> PDF
        </button>
      </div>


    </div>
  </div>
</ng-template>

<!-- MODAL: Buscar Invitado -->
<ng-template #modalBuscarInvitado let-modal>
  <div class="card border-4 rounded-3">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
      <h5 class="mb-0"><strong>BUSCAR INVITADO</strong></h5>
      <button type="button" class="btn-close btn-close-white" (click)="cerrarModalBuscarInvitado()"
        aria-label="Close"></button>
    </div>

    <div class="modal-body">
      <div class="mb-3">
        <label class="form-label">N° DOCUMENTO</label>
        <input type="text" class="form-control" [(ngModel)]="cedulaBuscaInvitado"
          placeholder="Ingrese el número de documento">
      </div>
      <div class="mb-3 text-end">
        <div class="d-flex justify-content-end gap-2 flex-wrap">
          <button class="btn btn-outline-success" type="button" (click)="abrirModalCrearInvitado()">
            <i class="fa fa-user-plus me-1"></i>Crear invitado
          </button>
          <button class="btn btn-primary" type="button" (click)="buscarPersonaInvitado()">
            <span *ngIf="!cargandoBuscaInvitado"><i class="fa fa-search me-1"></i>Buscar</span>
            <span *ngIf="cargandoBuscaInvitado" class="spinner-border spinner-border-sm"></span>
          </button>
        </div>
      </div>

      <div *ngIf="errorBuscaInvitado" class="alert alert-danger small">{{ errorBuscaInvitado }}</div>

      <div *ngIf="personaBuscadaInvitado" class="card p-2">
        <div><strong>{{ personaBuscadaInvitado.nombre }}</strong></div>
        <div class="small text-primary">N° DOCUMENTO: {{ personaBuscadaInvitado.cedula }}</div>
        <div class="mt-2">
          <button class="btn btn-success btn-sm" type="button" (click)="confirmarAgregarInvitado()">Agregar
            invitado</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #modalCrearInvitado let-modal>
  <div class="card border-4 rounded-3">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
      <h5 class="mb-0"><strong>CREAR INVITADO</strong></h5>
      <button type="button" class="btn-close btn-close-white" (click)="cerrarModalCrearInvitado()"
        aria-label="Close"></button>
    </div>

    <div class="modal-body">
      <form [formGroup]="formCrearInvitado">
        <div class="row g-3">
          <div class="col-md-4">
            <label class="form-label">Tipo de documento <span class="text-danger">*</span></label>
            <ng-select [items]="tiposDocumentoInvitado" bindLabel="descripcion" bindValue="id"
              placeholder="Selecciona tipo de documento" formControlName="tipo_documento"
              [class.is-invalid]="formCrearInvitado.get('tipo_documento')?.invalid && formCrearInvitado.get('tipo_documento')?.touched"
              [clearable]="true" [searchable]="true">
            </ng-select>
            <div class="invalid-feedback d-block"
              *ngIf="formCrearInvitado.get('tipo_documento')?.invalid && formCrearInvitado.get('tipo_documento')?.touched">
              El tipo de documento es obligatorio.
            </div>
          </div>

          <div class="col-md-4">
            <label class="form-label">Cédula <span class="text-danger">*</span></label>
            <input type="number" class="form-control" formControlName="cc" placeholder="Ingrese la cédula"
              [class.is-invalid]="formCrearInvitado.get('cc')?.invalid && formCrearInvitado.get('cc')?.touched" />
            <div class="invalid-feedback d-block"
              *ngIf="formCrearInvitado.get('cc')?.invalid && formCrearInvitado.get('cc')?.touched">
              La cédula es obligatoria.
            </div>
          </div>

          <div class="col-md-4">
            <label class="form-label">Teléfono <span class="text-danger">*</span></label>
            <input type="number" class="form-control" formControlName="telefono" placeholder="Ingrese el teléfono"
              [class.is-invalid]="formCrearInvitado.get('telefono')?.invalid && formCrearInvitado.get('telefono')?.touched" />
            <div class="invalid-feedback d-block"
              *ngIf="formCrearInvitado.get('telefono')?.invalid && formCrearInvitado.get('telefono')?.touched">
              El teléfono es obligatorio.
            </div>
          </div>

          <div class="col-md-4">
            <label class="form-label">Primer nombre <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="primer_nombre" placeholder="Primer nombre"
              [class.is-invalid]="formCrearInvitado.get('primer_nombre')?.invalid && formCrearInvitado.get('primer_nombre')?.touched" />
            <div class="invalid-feedback d-block"
              *ngIf="formCrearInvitado.get('primer_nombre')?.invalid && formCrearInvitado.get('primer_nombre')?.touched">
              El primer nombre es obligatorio.
            </div>
          </div>

          <div class="col-md-4">
            <label class="form-label">Segundo nombre</label>
            <input type="text" class="form-control" formControlName="segundo_nombre" placeholder="Segundo nombre" />
          </div>

          <div class="col-md-4">
            <label class="form-label">Primer apellido <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="primer_apellido" placeholder="Primer apellido"
              [class.is-invalid]="formCrearInvitado.get('primer_apellido')?.invalid && formCrearInvitado.get('primer_apellido')?.touched" />
            <div class="invalid-feedback d-block"
              *ngIf="formCrearInvitado.get('primer_apellido')?.invalid && formCrearInvitado.get('primer_apellido')?.touched">
              El primer apellido es obligatorio.
            </div>
          </div>

          <div class="col-md-4">
            <label class="form-label">Segundo apellido</label>
            <input type="text" class="form-control" formControlName="segundo_apellido" placeholder="Segundo apellido" />
          </div>
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <button class="btn btn-primary" type="button" (click)="crearInvitadoYBuscar()" [disabled]="cargandoCrearInvitado">
        <span *ngIf="!cargandoCrearInvitado"><i class="icofont icofont-save me-1"></i>Guardar invitado</span>
        <span *ngIf="cargandoCrearInvitado">
          <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Guardando...
        </span>
      </button>
      <button class="btn btn-secondary" type="button" (click)="cerrarModalCrearInvitado()"
        [disabled]="cargandoCrearInvitado">Cancelar</button>
    </div>
  </div>
</ng-template>

<!-- MODAL: Listado de Actas -->
<ng-template #modalActasComite let-modal>
  <div class="card border-4 rounded-3">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
      <h5 class="mb-0"><strong>ACTAS DEL COMITÉ #{{ numeroComiteActasModal }}</strong></h5>
      <button type="button" class="btn-close btn-close-white" (click)="modal.dismiss()" aria-label="Close"></button>
    </div>

    <div class="modal-body">
      <div class="alert alert-primary fs-6 mb-3">
        <i class="icofont icofont-info-circle me-1"></i>
        Listado de actas registradas para el comité <strong>No. {{ numeroComiteActasModal }}</strong>
      </div>

      <div class="row mb-2 g-2">
        <div class="col-sm-12 col-md-4 ms-auto">
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Buscar acta, fecha, hora o integrante..."
              [(ngModel)]="searchTextActasModal" (input)="aplicarFiltroActasModal()" />
            <span class="input-group-text">
              <i class="fa fa-search"></i>
            </span>
          </div>
        </div>
      </div>

      <div *ngIf="cargandoActasModal" class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Cargando...</span>
        </div>
        <p class="mt-2 text-dark">Cargando actas...</p>
      </div>

      <div class="table-responsive my-3" *ngIf="!cargandoActasModal && actasModalListaFiltrada?.length">
        <table class="table table-bordered" id="tblActasModal">
          <thead class="bg-primary text-white">
            <tr>
              <th width="50"></th>
              <th class="text-center">ACTA</th>
              <th class="text-center">INTEGRANTES</th>
              <th class="text-center">FECHA</th>
              <th class="text-center">HORA</th>
              <th class="text-center">TIPO REUNIÓN</th> 
              <th class="text-center">TEMAS TRATADOS</th>            
              <th class="text-center">ACCIONES</th>
            </tr>
          </thead>
          <tbody>

  <ng-container
    *ngFor="let acta of actasModalListaFiltrada
      | paginate : {
          id: 'actasComite',
          itemsPerPage: pageSizeActasModal,
          currentPage: pageActasModal
        }">

    <!-- FILA PRINCIPAL -->
    <tr class="align-middle">

      <td class="text-center">

        <button
          class="btn btn-sm btn-outline-primary"
          (click)="toggleRow(acta)">

          <i
            class="icofont"
            [ngClass]="{
              'icofont-rounded-down': expandedRowId === acta.id,
              'icofont-rounded-right': expandedRowId !== acta.id
            }">
          </i>

        </button>

      </td>

      <td class="text-center">
        <span class="badge bg-primary">
          Acta #{{ acta.id }}
        </span>
      </td>
      <td class="text-center">

        <span class="badge bg-info">

          {{ acta.integrantes?.length +" Integrantes" || 0 }}

        </span>

      </td>

     <td class="text-center">
        {{ acta.fecha_reunion | date:'dd/MM/yyyy' }}
      </td>

      <td class="text-center">
        {{ acta.hora_inicio }} - {{ acta.hora_finalizacion }}
      </td>

      <td class="text-center">
        {{ acta.tipoActa?.descripcion || '-' }}
      </td>

       <td class="text-center" style="width: 15%;">
        <span class="">
          Acta #{{ acta.temas_tratados }}
        </span>
      </td>
      <td class="text-center">
        <div class="d-flex justify-content-center gap-1">
          <button class="btn btn-sm btn-outline-success rounded-pill btn-rounded"
            (click)="editarActaComite(numeroComiteActasModal, acta.id,acta.integrantes,acta)" ngbTooltip="Editar Acta de Reuníon">
            <i class="icon icon-pencil" style="font-size:.85rem;"></i>
          </button>
          <button class="btn btn-sm btn-outline-warning rounded-pill btn-rounded"
            (click)="descargarDocumentoActaComite(numeroComiteActasModal, acta.id)" ngbTooltip="Descargar Acta de Reuníon">
            <i class="icon icon-download" style="font-size:.85rem;"></i>
          </button>
        </div>
      </td>
    

    </tr>

    <!-- FILA EXPANDIDA -->

    <tr *ngIf="expandedRowId === acta.id">

      <td colspan="8" class="">

        <div class="p-3">

          <div class="d-flex align-items-center mb-3">

            <i class="icofont icofont-users-alt-4 me-2"></i>

            <h6 class="mb-0 fw-bold">
              INTEGRANTES DE LA REUNIÓN
            </h6>

          </div>

          <div *ngIf="acta.integrantes?.length" class="table-responsive">
          
            <table class="table table-sm table-bordered table-hover">
          
              <thead class="table bg-primary">
          
                <tr>
          
                  <th >DOCUMENTO</th>
                  <th>NOMBRE COMPLETO</th>
                  <th>CARGO EN EL COMITÉ</th>
          
                </tr>
          
              </thead>
          
              <tbody>
          
                <tr *ngFor="let integrante of acta.integrantes">
          
                  <td>
          
                    {{ integrante.cedula }}
          
                  </td>
                  <td>
          
                    {{ integrante.nombre }}
          
                  </td>
          
                  <td>
          
                    <span class="badge bg-secondary">
          
                      {{ integrante.funcionDetalle.descripcion }}
          
                    </span>
          
                  </td>
          
                </tr>
          
              </tbody>
          
            </table>
          
          </div>

          <div
            *ngIf="!acta.integrantes?.length"
            class="text-center text-muted py-3">

            No hay integrantes registrados

          </div>

        </div>

      </td>

    </tr>

  </ng-container>

</tbody>
        </table>
      </div>

      <div class="text-center py-4 text-primary" *ngIf="!cargandoActasModal && !actasModalListaFiltrada?.length">
        <i class="icofont icofont-file-alt" style="font-size: 32px;"></i>
        <p class="mb-0 mt-2">No hay actas registradas para este comité</p>
      </div>

      <div class="d-flex justify-content-between align-items-center mt-4 flex-wrap gap-2"
        *ngIf="!cargandoActasModal && actasModalListaFiltrada?.length">
        <div class="d-flex align-items-center">
          <label for="pageSizeActasModal" class="me-2">Mostrar:</label>
          <select id="pageSizeActasModal" class="form-select w-auto" [(ngModel)]="pageSizeActasModal"
            (change)="pageActasModal = 1">
            <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
          </select>
          <span class="ms-2">registros por página</span>
        </div>

        <div class="text-center flex-grow-1">
          Total Registros:
          <a class="badge badge-primary"><b>{{ actasModalListaFiltrada?.length || 0 }}</b></a>
        </div>

        <div class="text-end paginador-personalizado">
          <pagination-controls id="actasComite" (pageChange)="pageActasModal = $event" [maxSize]="5"
            [directionLinks]="true" [autoHide]="true" previousLabel="Anterior" nextLabel="Siguiente">
          </pagination-controls>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">

      <div class="w-100 d-flex justify-content-between align-items-center">

        <span class="text-dark">

          Mostrando
          <strong>
            {{ actasModalListaFiltrada?.length || 0 }}
          </strong>
          registros

        </span>

        <button
          class="btn btn-secondary"
          (click)="modal.dismiss()">

          <i class="icofont icofont-close me-1"></i>

          Cerrar

        </button>

      </div>

    </div>

  

</ng-template>

<ng-template #modalDetalleActaComite let-modal>

  <div class="card border-4 rounded-3">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
      <h5 class="mb-0"><strong>INTEGRANTES DE LA REUNIÓN #{{ actaDetalleSeleccionada?.numeroActa }}</strong></h5>
      <button type="button" class="btn-close btn-close-white" (click)="cerrarDetalleActaModal()"
        aria-label="Close"></button>
    </div>

    <div class="modal-body" *ngIf="actaDetalleSeleccionada">
      <!-- TOTAL -->
      <div class="row">
        <div class="col-12 col-md-12 col-sm-12 col-xl-4 my-5">
          <div class="card stats-card total-card h-100 border-0">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">

                <div>
                  <p class="stats-title">NÚMERO DE ACTA</p>
                  <h2 class="stats-number">
                    <strong class="text-dark">#{{ actaDetalleSeleccionada.numeroActa }}</strong>
                  </h2>
                </div>

                <div class="stats-icon bg-primary-subtle">
                  <i class="icofont icofont-file-document text-primary"></i>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-12 col-sm-12 col-xl-4 my-5">
          <div class="card stats-card total-card h-100 border-0">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">

                <div>
                  <p class="stats-title">FECHA</p>
                  <h5 class="stats-number">
                    <strong class="text-dark">{{ actaDetalleSeleccionada.fecha | date:'dd/MM/yyyy' }}</strong>
                  </h5>
                </div>

                <div class="stats-icon bg-primary-subtle">
                  <i class="icofont icofont-calendar text-primary"></i>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-12 col-sm-12 col-xl-4 my-5">
          <div class="card stats-card total-card h-100 border-0">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">

                <div>
                  <p class="stats-title">TIPO DE REUNIÓN</p>
                  <h5 class="stats-number">
                    <strong class="text-dark">{{ actaDetalleSeleccionada.tipoReunion || '-' }}</strong>
                  </h5>
                </div>

                <div class="stats-icon bg-primary-subtle">
                  <i class="icofont icofont-file-document text-primary"></i>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      
    
       <div class="table-responsive" *ngIf="actaDetalleSeleccionada.integrantes?.length">
                <table class="table table-bordered mb-0">
                  <thead class="bg-primary text-white">
                    <tr>
                      <th class="text-center">N° DOCUMENTO</th>
                      <th class="text-center">NOMBRE</th>
                      <th class="text-center">CARGO EN EL COMITÉ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let integrante of actaDetalleSeleccionada.integrantes" class="text-center">
                      <td>{{ integrante.cedula }}</td>
                      <td class="text-start">{{ integrante.nombre }}</td>
                      <td><span class="badge bg-primary">{{ integrante.funcion }}</span></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="text-center text-dark py-3" *ngIf="!actaDetalleSeleccionada.integrantes?.length">
                No hay integrantes registrados
              </div>

      <!--  <div class="row g-3">
        <div class="col-12">
          <div class="card border-0 shadow-sm">
            <div class="card-header bg-light d-flex align-items-center justify-content-between flex-wrap gap-2">
              <strong>Compromisos</strong>
            </div>
            <div class="card-body p-0">
              <div class="table-responsive" *ngIf="actaDetalleSeleccionada.compromisosActa?.length">
                <table class="table table-bordered mb-0">
                  <thead class="bg-primary text-white">
                    <tr>
                      <th class="text-center">RESPONSABLE</th>
                      <th class="text-center">COMPROMISO</th>
                      <th class="text-center">FECHA</th>
                      <th class="text-center">AVANCE</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let compromiso of actaDetalleSeleccionada.compromisosActa" class="align-middle">
                      <td class="text-center">{{ compromiso.responsable }}</td>
                      <td>{{ compromiso.compromiso }}</td>
                      <td class="text-center">{{ compromiso.fecha | date:'dd/MM/yyyy' }}</td>
                      <td>
                        <div class="d-flex align-items-center gap-2">
                          <div class="progress flex-grow-1" style="height: 8px;">
                            <div class="progress-bar" role="progressbar" [style.width.%]="compromiso.avance || 0"
                              [attr.aria-valuenow]="compromiso.avance || 0" aria-valuemin="0" aria-valuemax="100"></div>
                          </div>
                          <span class="badge bg-info text-dark">{{ compromiso.avance || 0 }}%</span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="text-center text-dark py-3" *ngIf="!actaDetalleSeleccionada.compromisosActa?.length">
                No hay compromisos registrados
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="cerrarDetalleActaModal()">Cerrar</button>
      <button type="button" class="btn btn-outline-primary" (click)="verDocumentoActaGrupo(actaDetalleSeleccionada)">
        Ver documento
      </button>
      <button type="button" class="btn btn-primary"
        (click)="descargarPdfActaGrupo(actaDetalleSeleccionada, actaDetalleSeleccionada?.numeroActa)">
        Descargar documento
      </button>
    </div>
  </div>
</ng-template>

<ng-template #modalFuncionDetalle let-modal>
  <div class="card border-4 rounded-3">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
      <h5 class="mb-0"><strong>AGREGAR RELACIÓN DE FUNCIÓN</strong></h5>
      <button type="button" class="btn-close btn-close-white" (click)="modal.dismiss()" aria-label="Close"></button>
    </div>

    <div class="modal-body">
      <form [formGroup]="formFuncionDetalle">
        <div class="row g-3">
          <div class="col-12 col-md-6">
            <label class="form-label">
              FUNCIÓN INTEGRANTE <span class="text-danger">*</span>
            </label>
            <ng-select [items]="opcionesNFuncion" bindLabel="label" bindValue="value" placeholder="Selecciona función"
              formControlName="nFuncionDetalle" [clearable]="true" [searchable]="true" notFoundText="No disponible"
              (change)="onFuncionDetalleModalChange($event)"></ng-select>
            <small class="text-dark" *ngIf="cargandoFuncionesIntegranteDetalle">Cargando opciones...</small>
          </div>

          <div class="col-12 col-md-6">
            <label class="form-label">
              DETALLE INTEGRANTE <span class="text-danger">*</span>
            </label>
            <textarea class="form-control" rows="4" formControlName="descripcionDetalle"
              placeholder="Escribe el detalle que quieras agregar, por ejemplo: responsable de seguimiento, apoyo operativo, coordinador de reportes..."
              maxlength="1000"
              [class.is-invalid]="formFuncionDetalle.get('descripcionDetalle')?.invalid && formFuncionDetalle.get('descripcionDetalle')?.touched"></textarea>
            <div class="d-flex justify-content-between align-items-center mt-1">
              <small class="text-primary">
                {{ (formFuncionDetalle.get('descripcionDetalle')?.value?.length || 0) }} / 1000
              </small>
            </div>
            <div class="invalid-feedback d-block"
              *ngIf="formFuncionDetalle.get('descripcionDetalle')?.invalid && formFuncionDetalle.get('descripcionDetalle')?.touched">
              El detalle es obligatorio y debe tener al menos 3 caracteres.
            </div>
            <small class="text-dark">
              Puedes escribir cualquier detalle que necesites guardar para esta función.
            </small>
          </div>
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <button class="btn btn-primary" type="button" (click)="guardarFuncionIntegranteDetalle(modalFuncionDetalleRef)"
        [disabled]="!formFuncionDetalle.valid || cargando">
        <span *ngIf="!cargando"><i class="icofont icofont-save me-1"></i>Guardar</span>
        <span *ngIf="cargando">
          <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Guardando...
        </span>
      </button>
      <button class="btn btn-secondary" type="button" (click)="modal.dismiss()" [disabled]="cargando">Cancelar</button>
    </div>
  </div>
</ng-template>

<!-- MODAL: Editar Integrante -->
<ng-template #modalEditarIntegrante let-modal>
  <div class="card border-4 rounded-3">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
      <h5 class="mb-0"><strong>EDITAR INTEGRANTE DEL COMITÉ</strong></h5>
      <button type="button" class="btn-close btn-close-white" (click)="modal.dismiss()" aria-label="Close"></button>
    </div>

    <div class="modal-body">
      <form [formGroup]="formEditarIntegrante">

        <!-- Información del integrante -->
        <div class="border-0 shadow-sm mb-4">

          <div class="card-header bg-primary text-white">
            <h5 class="mb-0 fw-semibold">
              <i class="fa fa-user me-2"></i>
              INFORMACIÓN DEL INTEGRANTE
            </h5>
          </div>

          <div class="card-body">

            <div class="d-flex align-items-center mb-4">

              <div
                class="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center fw-bold me-3"
                style="width:60px; height:60px; font-size:1.3rem;">

                {{ formEditarIntegrante.get('nombre')?.value?.charAt(0) || '?' }}

              </div>

              <div>
                <h6 class="mb-1 fw-bold">
                  {{ formEditarIntegrante.get('nombre')?.value }}
                </h6>

                <span class="badge bg-secondary">
                  {{ formEditarIntegrante.get('cargoLaboral')?.value }}
                </span>
              </div>

            </div>

            <div class="row g-3">

              <div class="col-md-4">

                <label class="form-label text-dark small mb-1">
                  NÚMERO DE DOCUMENTO:
                </label>

                <div class="form-control bg-light border-0">
                  {{ formEditarIntegrante.get('cedula')?.value }}
                </div>

              </div>

              <div class="col-md-4">

                <label class="form-label text-dark small mb-1">
                  NOMBRE:
                </label>

                <div class="form-control bg-light border-0 text-truncate">
                  {{ formEditarIntegrante.get('nombre')?.value }}
                </div>

              </div>

              <div class="col-md-4">

                <label class="form-label text-dark small mb-1">
                  CARGO LABORAL
                </label>

                <div class="form-control bg-light border-0">
                  {{ formEditarIntegrante.get('cargoLaboral')?.value }}
                </div>

              </div>

            </div>

          </div>

        </div>

        <!-- Asignación comité -->
        <div class="shadow-sm">

          <div class="card-header bg-primary text-white">
            <h5 class="mb-0 fw-semibold">
              <i class="fa fa-cogs me-2"></i>
              ASIGNACION EN EL COMITÉ
            </h5>
          </div>

          <div class="card-body">

            <!-- Función actual -->
            <div class="alert alert-primary py-2 mb-3" *ngIf="integranteEnEdicion?.funcionDetalle">

              <i class="fa fa-info me-1"></i>

              FUNCION ACTUAL:
              <strong>
                {{ integranteEnEdicion.funcionDetalle.descripcion }}
              </strong>

            </div>

            <!-- Selección nueva función -->
            <div class="mb-3">

              <label class="form-label fw-semibold">
                CARGO EN EL COMITÉ
                <span class="text-danger">*</span>
              </label>

              <ng-select [items]="funciones_mostrar" bindLabel="descripcion" bindValue="id"
                placeholder="Seleccione una función" formControlName="funcion" [clearable]="true" [searchable]="true"
                notFoundText="No disponible" [class.is-invalid]="
              formEditarIntegrante.get('funcion')?.invalid &&
              formEditarIntegrante.get('funcion')?.touched
            ">
              </ng-select>

              <div class="text-danger mt-1" *ngIf="
              formEditarIntegrante.get('funcion')?.invalid &&
              formEditarIntegrante.get('funcion')?.touched
            ">
                Debe seleccionar una función.
              </div>

            </div>

            <!-- Estado carga -->
            <div *ngIf="cargandoFunciones">

              <div class="alert alert-primary py-2 mb-0">

                <span class="spinner-border spinner-border-sm me-2" role="status">
                </span>

                Cargando funciones disponibles...

              </div>

            </div>

            <!-- Sin funciones -->
            <div *ngIf="
            !cargandoFunciones &&
            (!funciones_mostrar || funciones_mostrar.length === 0)
          ">

              <div class="alert alert-warning py-2 mb-0">

                <i class="icofont-warning me-1"></i>

                No hay funciones disponibles según las reglas de
                cargo o unicidad definidas para este comité.

              </div>

            </div>

          </div>

        </div>

      </form>
    </div>

    <div class="modal-footer">

      <button class="btn btn-secondary" (click)="modal.dismiss()">
        Cancelar
      </button>
      <button class="btn btn-primary" (click)="guardarCambiosIntegrante(modalEditarIntegranteRef)"
        [disabled]="!formEditarIntegrante.valid || cargandoGuardar">
        <span *ngIf="!cargandoGuardar"><i class="icofont icofont-save me-1"></i>Guardar Cambios</span>
        <span *ngIf="cargandoGuardar">
          <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Guardando...
        </span>
      </button>
    </div>
  </div>
</ng-template>

<!-- MODAL: Inactivar Integrante -->
<ng-template #modalInactivarIntegrante let-modal>
  <div class="card border-4 rounded-3">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
      <h5 class="mb-0"><strong>INACTIVAR INTEGRANTE DEL COMITÉ</strong></h5>
      <button type="button" class="btn-close btn-close-white" (click)="modal.dismiss()" aria-label="Close"></button>
    </div>

    <div class="modal-body">
      <div class="alert alert-primary small mb-3" *ngIf="integranteInactivar">
        <i class="icofont icofont-info-circle me-1"></i>
        Se inactivará a <strong>{{ integranteInactivar.nombre }}</strong> ({{ integranteInactivar.funcion }}).
      </div>

      <form [formGroup]="formInactivarIntegrante">
        <div class="card-body my-3">
          <div class="row g-3 mb-3">
            <div class="col-md-5">
              <label class="form-label">
                MOTIVO <span class="text-danger">*</span>
              </label>
              <ng-select [items]="comiteMotivo" bindLabel="descripcion" bindValue="id"
                placeholder="Selecciona un motivo" formControlName="motivo"
                [class.is-invalid]="formInactivarIntegrante.get('motivo')?.invalid && formInactivarIntegrante.get('motivo')?.touched"
                [clearable]="true" [searchable]="true" notFoundText="No hay motivos disponibles">
              </ng-select>
              <div class="invalid-feedback d-block"
                *ngIf="formInactivarIntegrante.get('motivo')?.invalid && formInactivarIntegrante.get('motivo')?.touched">
                El motivo es obligatorio.
              </div>
            </div>

            <div class="col-md-6">
              <label class="form-label">Observaciones <span class="text-danger">*</span></label>
              <textarea class="form-control" rows="3" formControlName="observaciones"
                [class.is-invalid]="formInactivarIntegrante.get('observaciones')?.invalid && formInactivarIntegrante.get('observaciones')?.touched"
                placeholder="Ingrese observaciones adicionales"></textarea>
              <div class="invalid-feedback">Las observaciones son obligatorias.</div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <button class="btn btn-danger" (click)="confirmarInactivarIntegrante(modalInactivarIntegranteRef)"
        [disabled]="!formInactivarIntegrante.valid || cargandoInactivar">
        <span *ngIf="!cargandoInactivar"><i class="icofont icofont-ban me-1"></i>Inactivar</span>
        <span *ngIf="cargandoInactivar">
          <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Procesando...
        </span>
      </button>
      <button class="btn btn-secondary" (click)="modal.dismiss()" [disabled]="cargandoInactivar">Cancelar</button>
    </div>
  </div>
</ng-template>

<!-- Modal para agregar integrante -->
<ng-template #modalAgregarIntegrante let-modal>
  <div class="card border-4 rounded-3">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
      <h5 class="mb-0"><strong>AGREGAR INTEGRANTE AL COMITÉ</strong></h5>
      <button type="button" class="btn-close btn-close-white" (click)="modal.dismiss()" aria-label="Close"></button>
    </div>

    <div class="modal-body">
      <div class="alert alert-primary fs-6 mb-3">
        <i class="icofont icofont-info-circle me-1"></i>
        Agregando integrante al comité <strong>No. {{ numeroComiteParaAgregar }}</strong>
      </div>

      <form [formGroup]="formAgregarIntegrante">

        <div class="card border-0 shadow-sm">
          <div class="card-body">

            <!-- Documento -->
            <div class="mb-3">

              <label class="form-label fw-semibold">
                NÚMERO DE DOCUMENTO:
                <span class="text-danger">*</span>
              </label>

              <div class="input-group">

                <span class="input-group-text">
                  <i class="fa fa-user"></i>
                </span>

                <input class="form-control" type="number" formControlName="cedula" placeholder="Ingrese documento"
                  (input)="onCedulaInputAgregar()" (blur)="buscarPersonaParaAgregar()">

                <span class="input-group-text" *ngIf="buscandoPersonaParaAgregar">

                  <span class="spinner-border spinner-border-sm">
                  </span>

                </span>

              </div>

            </div>

            <!-- Resultado búsqueda -->

            <div *ngIf="propietarioParaAgregar" class="card bg-light border-success mb-3">

              <div class="card-body py-2">

                <div class="d-flex justify-content-between">

                  <div>

                    <div class="fw-bold">
                      {{ propietarioParaAgregar.nombre }}
                    </div>

                    <small class="text-dark">
                      {{ propietarioParaAgregar.cargo_descripcion || 'Sin cargo registrado' }}
                    </small>

                  </div>

                  <div>

                    <span *ngIf="!personaYaAgregadaEnComite" class="badge bg-success">

                      Disponible

                    </span>

                    <span *ngIf="personaYaAgregadaEnComite" class="badge bg-danger">

                     La persona ya se encuentra asignada en el Comité

                    </span>

                  </div>

                </div>

              </div>

            </div>

            <!-- Mensajes -->

            <div *ngIf="mensajeBusquedaPersonaAgregar" class="alert py-2" [ngClass]="{
          'alert-danger': tipoMensajeBusquedaPersonaAgregar === 'danger',
          'alert-warning': tipoMensajeBusquedaPersonaAgregar === 'warning'
        }">

              {{ mensajeBusquedaPersonaAgregar }}

            </div>

            <!-- Cargo -->

            <div *ngIf="propietarioParaAgregar && !personaYaAgregadaEnComite">

              <label class="form-label fw-semibold">
                Cargo en el comité
                <span class="text-danger">*</span>
              </label>

              <ng-select [items]="funciones_mostrar" 
                bindLabel="descripcion" 
                bindValue="id" 
                formControlName="funcion"
                placeholder="Seleccione un cargo" [searchable]="true">

              </ng-select>

            </div>

          </div>
        </div>

      </form>
    </div>

    <div class="modal-footer">

      <button class="btn btn-secondary" (click)="modal.dismiss()" [disabled]="cargandoGuardar">Cancelar</button>
      <button class="btn btn-success" (click)="guardarNuevoIntegrante(modalAgregarIntegranteRef)"
        [disabled]="!formAgregarIntegrante.valid || cargandoGuardar || !propietarioParaAgregar">
        <span *ngIf="!cargandoGuardar"><i class="icofont icofont-save me-1"></i>Agregar Integrante</span>
        <span *ngIf="cargandoGuardar">
          <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Guardando...
        </span>
      </button>
    </div>
  </div>
</ng-template>

<!-- Modal para inactivar el comité completo -->
<ng-template #modalInactivarComite let-modal>
  <div class="card border-4 rounded-3">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
      <h5 class="mb-0"><strong>INACTIVAR COMITÉ COMPLETO</strong></h5>
      <button type="button" class="btn-close btn-close-white" (click)="modal.dismiss()" aria-label="Close"></button>
    </div>

    <div class="modal-body">
      <div class="alert alert-primary small mb-3">
        <i class="icofont icofont-warning-alt me-1"></i>
        <strong>ADVERTENCIA:</strong> Se inactivará el número de comité y TODOS sus integrantes.
      </div>

      <p class="text-dark small">
        <i class="icofont icofont-info-circle me-1"></i>
        El motivo y observaciones se registrarán automáticamente como "comite inactivo".
      </p>

      <div class="alert alert-primary small mt-3">
        <strong>Número de comité a inactivar:</strong> <span class="badge bg-info">{{ numeroComiteAInactivar }}</span>
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn btn-danger" (click)="confirmarInactivarComite(modalInactivarComiteRef)"
        [disabled]="cargandoInactivar">
        <span *ngIf="!cargandoInactivar"><i class="icofont icofont-ban me-1"></i>Confirmar Inactivación</span>
        <span *ngIf="cargandoInactivar">
          <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Procesando...
        </span>
      </button>
      <button class="btn btn-secondary" (click)="modal.dismiss()" [disabled]="cargandoInactivar">Cancelar</button>
    </div>
  </div>
</ng-template>

<!-- MODAL: Activar Integrante -->
<ng-template #modalActivarIntegrante let-modal>
  <div class="card border-4 rounded-3">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
      <h5 class="mb-0"><strong>ACTIVAR INTEGRANTE DEL COMITÉ</strong></h5>
      <button type="button" class="btn-close btn-close-white" (click)="modal.dismiss()" aria-label="Close"></button>
    </div>

    <div class="modal-body">
      <div class="alert alert-primary small mb-3" *ngIf="integranteActivar">
        <i class="icofont icofont-info-circle me-1"></i>
        Se activará a <strong>{{ integranteActivar.nombre }}</strong> ({{ integranteActivar.funcion }}).
      </div>

      <form [formGroup]="formActivarIntegrante">
        <div class="card-body my-3">
          <div class="row g-3 mb-3">
            <div class="col-md-5">
              <label class="form-label">
                MOTIVO <span class="text-danger">*</span>
              </label>
              <ng-select [items]="comiteMotivo2" bindLabel="descripcion" bindValue="id"
                placeholder="Selecciona un motivo" formControlName="motivo"
                [class.is-invalid]="formActivarIntegrante.get('motivo')?.invalid && formActivarIntegrante.get('motivo')?.touched"
                [clearable]="true" [searchable]="true" notFoundText="No hay motivos disponibles">
              </ng-select>
              <div class="invalid-feedback d-block"
                *ngIf="formActivarIntegrante.get('motivo')?.invalid && formActivarIntegrante.get('motivo')?.touched">
                El motivo es obligatorio.
              </div>
            </div>

            <div class="col-md-6">
              <label class="form-label">Observaciones <span class="text-danger">*</span></label>
              <textarea class="form-control" rows="3" formControlName="observaciones"
                [class.is-invalid]="formActivarIntegrante.get('observaciones')?.invalid && formActivarIntegrante.get('observaciones')?.touched"
                placeholder="Ingrese observaciones adicionales"></textarea>
              <div class="invalid-feedback">Las observaciones son obligatorias.</div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <button class="btn btn-success" (click)="confirmarActivarIntegrante(modalActivarIntegranteRef)"
        [disabled]="!formActivarIntegrante.valid || cargandoActivar">
        <span *ngIf="!cargandoActivar"><i class="icofont icofont-check-circled me-1"></i>Activar</span>
        <span *ngIf="cargandoActivar">
          <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Procesando...
        </span>
      </button>
      <button class="btn btn-secondary" (click)="modal.dismiss()" [disabled]="cargandoActivar">Cancelar</button>
    </div>
  </div>
</ng-template>

<!-- MODAL: Vista previa documento comité -->
<ng-template #modalVistaPreviaDocumentoComite let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ documentoComitePreviewNombre }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body p-0" style="height: 80vh;">
    <div class="d-flex align-items-center justify-content-center h-100" *ngIf="!documentoComitePreviewUrl">
      <div class="text-center">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Cargando...</span>
        </div>
        <p class="mt-2 text-dark">Cargando documento...</p>
      </div>
    </div>
    <iframe *ngIf="documentoComitePreviewUrl" [src]="documentoComitePreviewUrl"
      title="Vista previa documento comité PESV" style="width: 100%; height: 100%; border: 0;"
      (error)="onIframeError()"></iframe>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn-secondary" (click)="abrirDocumentoEnNuevaVentana()">
      <i class="icofont icofont-external-link me-1"></i>Abrir en nueva ventana
    </button>
    <button type="button" class="btn-secondary" (click)="modal.dismiss()">Cerrar</button>
    <button type="button" class="btn-primary" (click)="descargarDocumentoComiteActual()">Descargar</button>
  </div>
</ng-template>